<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="8" offset-sm="2">
        <div v-html="page.tekst"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8" offset-sm="2">
        <div v-html="page.tekst_2"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import page from '~/plugins/mixins/page';

export default {
  mixins: [page],
};
</script>
